<template>
  <div v-if="visible" class="c-warning-message">
    <WTooltip
      v-if="tooltip"
      :label="tooltip"
      class="c-warning-message__tooltip"
    >
      <div class="c-warning-message__wrapper">
        <WIcon :icon="icon" size="medium" />
        <WHelper>{{ title }}.</WHelper>
      </div>
    </WTooltip>

    <div v-else class="c-warning-message__wrapper">
      <WIcon :icon="icon" size="medium" />
      <WHelper>{{ title }}.</WHelper>
      <a v-if="dismissible" class="c-warning-message__cta" @click="close">
        Entendi
      </a>
    </div>
  </div>
</template>

<script>
import { WHelper, WIcon, WTooltip } from '@alice-health/wonderland-vue'

export default {
  components: {
    WIcon,
    WTooltip,
    WHelper
  },
  props: {
    title: {
      type: String,
      required: true
    },
    tooltip: { type: String, default: '' },
    icon: { type: String, required: true },
    dismissible: Boolean
  },
  data() {
    return {
      visible: true
    }
  },
  computed: {
    message() {
      return this.question && `Mensagem: ${this.question}`
    }
  },
  methods: {
    close() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_non-rendering';
.c-warning-message {
  background-color: var(--gl-color-shades-white);
  padding: var(--gl-spacing-04) 0 var(--gl-spacing-02);

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--gl-spacing-02);
  }

  &__cta {
    cursor: pointer;
    font-weight: 400;
  }
}
</style>
